import { RefObject, useEffect, useState } from "react";

export function useIsScrolledPast(
  targetRef?: RefObject<Element | null>,
  offset = 0
): boolean {
  const [scrolledPast, setScrolledPast] = useState(false);

  useEffect(() => {
    const target = targetRef?.current;

    if (!target || typeof IntersectionObserver === "undefined") {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.target.isConnected) {
          return;
        }

        const rootTop = entry.rootBounds?.top ?? 0;
        const leftAbove = entry.boundingClientRect.top <= rootTop + 1;

        setScrolledPast(!entry.isIntersecting && leftAbove);
      },
      { rootMargin: `${-offset}px 0px 0px 0px`, threshold: 0 }
    );

    observer.observe(target);

    return () => observer.disconnect();
  }, [targetRef, offset]);

  return scrolledPast;
}
